import React from "react";

import CssBaseline from "@mui/material/CssBaseline";
import {
  ThemeProvider,
  createTheme,
  // responsiveFontSizes,
} from "@mui/material/styles";
import PropTypes from "prop-types";
import { createThemeVariable } from "utils/theme";

export default function ThemeLoader(props) {
  // const theme = responsiveFontSizes(createTheme(themeColor));
  const theme = createTheme(createThemeVariable("light"));
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  );
}

ThemeLoader.propTypes = {
  children: PropTypes.element,
};
